import axios from "axios";

import { CUSTOMER_API_URL, DOMAIN, tenentId } from "../constant";
import { getToken } from "../utilities/utilsFunction";

export const GetScheme = (variable) =>
  new Promise(async (resolve, reject) => {
    const config = {
      method: "POST",
      url: `${CUSTOMER_API_URL}web/docsList`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v1",
      },
      data: variable,
    };
    axios(config)
      .then((data) => {
        resolve(data.data);
      })
      .catch((e) => {
        reject(e);
      });
  });

export const GetSchemeList = (variable) =>
  new Promise(async (resolve, reject) => {
    const config = {
      method: "POST",
      url: `${CUSTOMER_API_URL}web/allDocs`, // Previous was - "docsForAll"
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v1",
      },
      data: variable,
    };
    axios(config)
      .then((data) => {
        resolve(data.data);
      })
      .catch((e) => {
        reject(e);
      });
  });

export const GetSchemeById = (docId) =>
  new Promise(async (resolve, reject) => {
    const config = {
      method: "GET",
      url: `${CUSTOMER_API_URL}web/document/${docId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v1",
      },
      data: {},
    };
    axios(config)
      .then((data) => {
        resolve(data.data);
      })
      .catch((e) => {
        reject(e);
      });
  });

export const AddScheme = (data) =>
  new Promise(async (resolve, reject) => {
    var config = {
      method: "post",
      url: `${CUSTOMER_API_URL}web/addDocs`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v1",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const DeleteScheme = (docId) =>
  new Promise(async (resolve, reject) => {
    var config = {
      method: "delete",
      url: `${CUSTOMER_API_URL}web/deleteDoc/${docId}`,
      headers: {
        Authorization: await getToken(),
        version: "v1",
      },
    };

    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const UpdateSchemeStatus = (schemeId, status) =>
  new Promise(async (resolve, reject) => {
    var config = {
      method: "put",
      url: `${CUSTOMER_API_URL}web/updateStatus/${schemeId}/${status}`,
      headers: {
        Authorization: await getToken(),
        version: "v1",
      },
    };

    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const UpdateScheme = (data) =>
  new Promise(async (resolve, reject) => {
    var config = {
      method: "put",
      url: `${CUSTOMER_API_URL}web/updateDoc`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v1",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const GetUserScheme = (customerCode, appId, token) =>
  new Promise(async (resolve, reject) => {
    var data = `query {
        docsForUser(tenantId:"${tenentId}",customerCode:"${customerCode}"){
          userSchemes{ 
            scheme {
                docUrl
                language
            }    
          }
        }
    }`;
    var config = {
      method: "post",
      url: CUSTOMER_API_URL + "graphql",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
        version: "v1",
      },
      data: data,
    };
    axios(config)
      .then((data) => {
        resolve({ data: data.data.docsForUser });
      })
      .catch((error) => {
        reject(error);
      });
  });

export const SyncUpload = () =>
  new Promise(async (resolve, reject) => {
    const config = {
      method: "GET",
      url: `${CUSTOMER_API_URL}web/bulkUplad`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v1",
      },
    };
    axios(config)
      .then((data) => {
        resolve(data.data);
      })
      .catch((e) => {
        reject(e);
      });
  });

// ********** New Scheme APIs ************ ////
export const GetNewSchemeList = (variable) =>
  new Promise(async (resolve, reject) => {
    const config = {
      method: "GET",
      url: `${CUSTOMER_API_URL}scheme/fetchAllSchemesByTenant?tenant=${variable.tenant}&appId=${variable.appId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v2",
      },
    };
    axios(config)
      .then((data) => {
        resolve(data.data);
      })
      .catch((e) => {
        reject(e);
      });
  });

export const GetNewSchemeById = (docId) =>
  new Promise(async (resolve, reject) => {
    const config = {
      method: "GET",
      url: `${CUSTOMER_API_URL}scheme/fetchSchemeHdrDtl/${docId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v2",
      },
      data: {},
    };
    axios(config)
      .then((data) => {
        resolve(data.data);
      })
      .catch((e) => {
        reject(e);
      });
  });

// Add/Update Scheme
export const AddUpdateNewScheme = (data) =>
  new Promise(async (resolve, reject) => {
    var config = {
      method: "POST",
      url: `${CUSTOMER_API_URL}scheme/saveOrUpdate`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v2",
      },
      data: data,
    };
    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

// Sent Test Notification
export const SendTestNotification = (data) =>
  new Promise(async (resolve, reject) => {
    var config = {
      method: "POST",
      url: `${DOMAIN}/pushservice/notification/pushNotificationToDevices`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v2",
      },
      data: data,
    };
    axios(config)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

// Get Deep links
export const GetDeepLinks = (variable) =>
  new Promise(async (resolve, reject) => {
    const config = {
      method: "GET",
      url: `${CUSTOMER_API_URL}ag/user/menuList?appId=${variable.appId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v2",
      },
    };
    axios(config)
      .then((data) => {
        resolve(data.data);
      })
      .catch((e) => {
        reject(e);
      });
  });

// Get All Apps Ids
export const GetAllAppIds = () =>
  new Promise(async (resolve, reject) => {
    const config = {
      method: "GET",
      url: `${CUSTOMER_API_URL}ag/findAppDetailList`,
      headers: {
        "Content-Type": "application/json",
        Authorization: await getToken(),
        version: "v2",
      },
    };
    axios(config)
      .then((data) => {
        resolve(data.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
